module.exports = __webpack_public_path__ + "static/media/4-6.d3383f57.png";